export enum DeliverableReportTab {
  FINANCIAL = 'Financial',
  TECHNICAL = 'Technical',
}
